<template>
  <v-container>
    <v-card
      class="mx-auto my-12"
      max-width="700"
    >
      <template slot="progress">
        <v-progress-linear
          color="deep-purple"
          height="10"
          indeterminate
        ></v-progress-linear>
      </template>

      <v-img
        height="250"
        src="../../../assets/themes.svg"
      ></v-img>

      <v-list color="#EAEFF0">
        <v-list-group
          v-for="category in categories"
          :key="category.id"
          v-model="category.active"
          :prepend-icon="category.action"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="category.name"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="theme in category.themes"
            :key="theme.id"
            class="pointer"
            @click="goToEssayWriter(theme.id)"
          >
            <v-list-item-avatar>
              <v-icon
                dark
              >mdi-check-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content color="#A9ABAE">
              <v-list-item-title v-text="theme.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import CategoryService from '@/services/category/category'
export default {
  name: 'Themes',
  data () {
    return {
      categories: [],
      CategoryService: new CategoryService()
    }
  },
  mounted () {
    this.loadCategoryThemes()
  },
  methods: {
    async loadCategoryThemes () {
      try {
        const { data } = await this.CategoryService.listCategory()
        this.categories = data.data.map(category => ({
          ...category,
          action: 'mdi-folder',
          active: false
        }))
      } catch (error) {
        console.log(error)
      }
    },
    goToEssayWriter (themeId) {
      this.$router.push({ path: `redacao/${themeId}` })
    }
  }
}
</script>

<style scoped>
.container-background {
  height: 100%;
}

.filter-label {
  font-size: 25px;
  font-weight: 600;
}

.h3-section {
  font-size: 25px;
  font-weight: 600;
}

.line-#ff6501 {
  border-top: 1px solid #ff6600;
  border-bottom: 1px solid #ff6600;
}
.relative {
  position: relative;
}
/* BOX */
.box {
  cursor: pointer;
  position: relative;
  float: left;
  width: 300px;
  height: 180px;
  margin: 0px 10px 10px 0px;
  flex-shrink: 0;
  box-shadow: 0px 3px 5px 0px rgba(184, 175, 184, 1);
  background: url(../../../assets/travessia_box2.png);
  background-color: #3377b8;
  border-radius: 8px;
}
.box:hover {
  background: none;
  background-color: rgb(27, 113, 195, 0.8);
}

.line-white {
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
}
.box-title {
  text-align: center;
  color: white;
  font-weight: 600;
}
.h3-padding-bottom {
  padding-bottom: 1rem;
}
.box-description {
  text-align: center;
  color: white;
  padding: 10px;
}
.input-margin {
  margin-top: 1em;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .filter-label {
    display: block;
    text-align: center;
  }
  .input-margin {
    margin-top: 0;
  }
  .box {
    margin-bottom: 15px;
  }
}
</style>
